import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Box,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { can } from '../../Conections/LogConections';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { GetGreenHouseDataAPI, ListGreenmodules } from '../../Conections/GreenhouseConection';

// Datos de ejemplo para el grupo
let grupoEjemplo = {
    id: '',
    name: '',
    address: '',
    phone: ''
};

function GreenhouseShow() {

    const { getToken, getCompany } = useAuth();
    const goTo = useNavigate();
    const { id } = useParams();


    const [greenhouse, setGreenhouse] = useState(grupoEjemplo);
    const [greenmodules, setGreenmodules] = useState([{ id: '0', nombre: '', peso: 0, fecha: '', activa: true }]);
    const [openDialog, setOpenDialog] = useState(false);
    const [estudianteARetirar, setEstudianteARetirar] = useState(null);
    const [actividadAEliminar, setActividadAEliminar] = useState(null);

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/showgroup/:id");
                if (permisionCan === 1) {
                    let GreenhouseIn = await GetGreenHouseDataAPI(getToken(), getCompany(), id);
                    setGreenhouse(GreenhouseIn);
                    let modules = await ListGreenmodules(getToken(), getCompany(), id);
                    console.log(modules);
                    setGreenmodules(modules);
                }
                else {
                    goTo("/dashboard");
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [id, getCompany, getToken, goTo]);


    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEstudianteARetirar(null);
        setActividadAEliminar(null);
    };

    const handleRetirarEstudiante = () => {
        console.log(`Retirando estudiante: ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido}`);
        handleCloseDialog();
    };

    const handleEliminarActividad = (actividad) => {
        setActividadAEliminar(actividad);
        setOpenDialog(true);
    };

    const confirmarEliminarActividad = () => {
        setGreenhouse(prevGrupo => ({
            ...prevGrupo,
            actividades: prevGrupo.actividades.filter(act => act.id !== actividadAEliminar.id)
        }));
        handleCloseDialog();
    };

    const handleEditarActividad = (actividad) => {
        goTo("/greenhouse/editgreenmodule/" + actividad.id );
    };

    const handleVerActividad = (actividad) => {
        console.log(actividad);
        goTo("/greenhouse/showgreenmodule/" + actividad.id);
    };

    const handleAddActivity = () => {
        goTo("/greenhouse/creategreenmodule/" + id);
    };

    const handleEditar = (id) => {
        goTo("/greenhouse/editgreenhouse/"+id);
    };

    return (
        <Container component="main" maxWidth="md">
            <Typography component="h1" variant="h4" gutterBottom sx={{ mt: 4, mb: 2 }}>
                Consulta de Invernadero
            </Typography>

            <Grid container spacing={3}>
                {/* Tarjeta de Información del Grupo */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Información del Invernadero
                            <IconButton onClick={() => handleEditar(id)} color="primary">
                                <DriveFileRenameOutlineIcon />
                            </IconButton>
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography>Nombre: {greenhouse.name}</Typography>
                            <Typography>Direccion: {greenhouse.address}</Typography>
                            <Typography>Telefono: {greenhouse.phone}</Typography>
                        </Box>
                    </Paper>
                </Grid>

                {/* Tarjeta de Modulos */}
                <Grid item xs={12}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>Modulos
                            <IconButton color="primary" onClick={handleAddActivity} sx={{ ml: 1 }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Typography>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {greenmodules.map((actividad) => (
                                        <TableRow key={actividad.id}>
                                            <TableCell>{actividad.name}</TableCell>
                                            <TableCell align="center">
                                                <IconButton onClick={() => handleVerActividad(actividad)} color="primary">
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleEditarActividad(actividad)} color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                                {/*<IconButton onClick={() => handleEliminarActividad(actividad)} color="secondary">
                                                    <DeleteIcon />
                                                </IconButton>*/}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>

            </Grid>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ textAlign: 'center' }}
            >
                <DialogContent>
                    <WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                    <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                        {estudianteARetirar
                            ? "¿Está seguro de retirar al estudiante del grupo?"
                            : "¿Está seguro de eliminar esta actividad?"}
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        {estudianteARetirar
                            ? `Esta acción retirará a ${estudianteARetirar?.nombre} ${estudianteARetirar?.apellido} del grupo.`
                            : `Esta acción eliminará la actividad "${actividadAEliminar?.nombre}" del grupo.`}
                        Esta acción no se puede deshacer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Cancelar
                    </Button>
                    <Button
                        onClick={estudianteARetirar ? handleRetirarEstudiante : confirmarEliminarActividad}
                        variant="contained"
                        color="error"
                        autoFocus
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default GreenhouseShow;

